// External dependencies
import React from 'react';
import Transition from 'react-transition-group/Transition';

import {observer} from 'mobx-react';

// Internal dependencies
import Spinner from '../Spinner'

const duration = 200;

const defaultStyle = {
    transition: `all ${duration}ms ease-out`,
    opacity: 0,
};

const transitionStyles = {
    entering: { opacity: 0 },
    entered:  { opacity: 1 },
    exited: { display: 'none'},
};

export default observer((props) => {
    return <Transition in={props.show} timeout={duration} appear={true}>
        {(state) => (
            <div style={{...defaultStyle, ...transitionStyles[state]}} className={`dimmer status ${props.type}`}>
                <Spinner className='huge' stopped={!props.processing} />
                <p style={{marginTop: '1em'}} dangerouslySetInnerHTML={{__html: props.message}} />
            </div>
        )}
    </Transition>
})



// WEBPACK FOOTER //
// ./src/elements/Status/Status.js